module.exports = __webpack_public_path__ + "img/turbo-features7.3341387d.png";